import { useMemo } from 'react';
import { useApi } from '../infrastructure/useApi';
import { DEFAULT_API_OPTIONS } from '../infrastructure/defaults';
import { API_URLS } from '../apiUrls';
import { API_METHODS } from '../constants/apiMethods';

/**
 * Hook for accessing Email API methods.
 *
 * Usage:
 * const { sendEmail, cancel } = useEmailApi();
 * await sendEmail(payload);
 *
 * Cancellation scope:
 * - cancel() applies to requests started by this hook instance.
 * - For independent cancellation scopes, create separate hook instances.
 */
export const useEmailApi = (baseOptions = DEFAULT_API_OPTIONS) => {
	const { call, cancel } = useApi(baseOptions);

	return useMemo(
		() => ({
			sendEmail: (payload, options = {}) =>
				call({
					url: API_URLS.email.send(),
					method: API_METHODS.POST,
					payload,
					options,
				}),

			cancel,
		}),
		[call, cancel]
	);
};
